import { defineComponent as _defineComponent } from 'vue'
import { ObjectType } from '@/@types/graphql-types';
import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import BuyBoxOfferNewPresentation from '@/components/experiments/OverProviderExp/components/BuyBoxOfferNewPresentation.vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { CatalogueItem } from '@/helpers/promotion-helper';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { useExperiment } from '@/libraries/experiment';
import { BuyBoxFilterOptions } from '@/stores/user.store';
import { computed, defineAsyncComponent } from 'vue';
import { PlanOffer } from '@/features/buybox/components/list/ListPromotionRow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowOfferPresentation',
  props: {
    title: null,
    promotionOffer: null,
    packagePlan: null,
    catalogueItem: null,
    inPromotionCatalogue: { type: Boolean },
    isHighlighted: { type: Boolean },
    filterOption: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	promotionOffer: TitleOfferFragment | null;
	packagePlan: PlanOffer | null;
	catalogueItem: CatalogueItem | null;
	inPromotionCatalogue?: boolean;
	isHighlighted?: boolean;
	// OVER_PROVIDER_EXP_V2
	filterOption?: BuyBoxFilterOptions;
	// OVER_PROVIDER_EXP_V2
};

const DisclaimerButton = defineAsyncComponent(() => import('@/features/buybox/components/DisclaimerButton.vue'));



const { tc, t } = useI18n();

const { activeVariantWithControlGroup: overProviderExpVariant } = useExperiment('OVER_PROVIDER_EXP_V3');

const subText = computed(() => {
	if (!props.promotionOffer) return '';

	const provider = props.promotionOffer?.package.clearName;

	if (props.inPromotionCatalogue) {
		return t('WEBAPP_FREE_TRIAL_TEXT', { provider });
	}

	return props.title.objectType === ObjectType.Movie
		? t('WEBAPP_WATCH_SIMILAR_MOVIES_FREE_ON_X', { provider })
		: t('WEBAPP_WATCH_SIMILAR_TV_SHOWS_FREE_ON_X', { provider });
});

const highlightedCTAText = computed(() => {
	if (props.title.__typename === 'Show' || props.title.__typename === 'Season') return tc('WEBAPP_OTHER_SHOWS');
	if (props.title.__typename === 'Movie') return tc('WEBAPP_OTHER_MOVIES');
	return '';
});

const showDisclaimerButton = computed(() => {
	return props.promotionOffer?.package.packageId === 350 && props.packagePlan?.retailPrice;
});

return { __sfc: true,DisclaimerButton, props, tc, t, overProviderExpVariant, subText, highlightedCTAText, showDisclaimerButton, BuyBoxOfferNewPresentation }
}

})